/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ product: NonNullable<unknown>, qty: NonNullable<unknown> }} Notif_Stock_Low_SummaryInputs */

const vi_notif_stock_low_summary = /** @type {(inputs: Notif_Stock_Low_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.product} · tồn ${i?.qty}`)
};

/**

* @param {Notif_Stock_Low_SummaryInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const notif_stock_low_summary = /** @type {((inputs: Notif_Stock_Low_SummaryInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notif_Stock_Low_SummaryInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_notif_stock_low_summary(inputs)
});